<app-localization [position]="position" [ellipsis]="ellipsis" [localization]="location|translate"
[data]="ride" type="telemetry" (poiClick)="openPoiPopup($event)"></app-localization>
